export const ta = {
    "TRIGGER_LISTEN": "செயலாக்க படுத்துவதற்கு கவனம் கொள்",
    "ASSIST_EMPTY_MSG": "ஏஜெண்ட் ஏஐ உங்கள் உரையாடலை நன்றாக கேட்கின்றது மற்றும் தொடர்ந்து உதவ உள்ளது.",
    "MYBOT_TRIGGET_LISTEN": "தற்போது ஏன் என்னைப் படைக்கவில்லை",
    "MYBOT_EMTPY_MSG": "எனது பாடத்தில் ஒரு பணியை தொடங்க என்னை தேடுகின்றது மற்றும் உங்கள் விருப்பமான பணிக்கு \"\"ஏஜெண்ட் உள்ளிட்டு ஓட்டம்\"\" விருப்பத்தைத் தேர்வு செய்க.",
    "PROACTIVE_MODE": "முன்னியல் நிலை",
    "SETTINGS": "அமைப்புகள்",
    "HELP_AND_SUPPORT": "உதவி & ஆதரவு",
    "HELP": "உதவி",
    "LANGUAGE": "மொழி",
    "THEME": "தீம்",
    "FILE_NAME":"கோப்பு பெயர்",
    "AUTO_SCROLL_TOOLTIP":"உதவி தாவல், என் பாட் மற்றும் உரைத் தாவல் உள்ளடக்கத்தின் தானாக ஸ்க்ரோலிங் கட்டுப்படுத்துகிறது",
    "AUTOMATIC": "தானியங்கி",
    "DARK": "கருப்பான",
    "LIGHT": "வெள்ளம்",
    "THEME_DESC": "இது உங்கள் அமைப்பு இயல்புடன் பயன்படுத்தும்",
    "DOCUMENTATION": "ஆவணங்கள்",
    "DOC_DESC": "எங்கள் ஆழமான ஆவணங்களைப் பார்க்கவும்.",
    "FAQ_U": "சமூகம் அனுப்புங்கள்",
    "FAQ_DESC": "ஏஜெண்ட் ஏஐ பற்றி அனுப்பப்பட்ட செயல்களைப் பார்க்கவும்.",
    "KORE_ACADEMY": "கோர் அகாடமி",
    "KORE_ACA_DESC": "அகாடமி பாடங்களைப் பார்க்கும்போது ஏஜெண்ட் ஏஐ பற்றி மேலும் அறியுங்கள்.",
    "SEARCH": "தேடு",
    "MY_BOT": "என் தொலைபேசி",
    "ASSIST": "உதவு",
    "TAB_TEXT":"டேப்கள் செயல்படுத்தப்படவில்லை! குறைந்தபட்சம் ஒரு டேப்பை செயல்படுத்தவும்",
    "TRANSCRIPT": "பதிவை",
    "TAP_SEARCH":"தேட அழுத்தவும்",
    "HISTORY": "வரலாறு",
    "STARTOVER": "மீண்டும் தொடங்கு",
    "RESTART_INPUTS": "சரியான உள்ளீட்டுடன் மீண்டும் தொடங்கு",
    "ASKCUSTOMER": "வாடிக்கையாளரை வினாக்கு",
    "TELLCUSTOMER": "வாடிக்கையாளருக்கு சொல்லுங்கள்",
    "WELCOME_MSG": "வரவேற்கிறேன் செய்தியை",
    "SEND": "அனுப்பு",
    "SENT": "அனுப்பப்பட்டது",
    "AWAITING": "பதிலைக் காத்திருக்கிறேன் | தொடர வேண்டும்",
    "OVERRIDE": "தொடர வேண்டும்",
    "OVERRIDE_FILE": "தொடர கேட்டியிடு",
    "ACCEPT_RESPONSE": "பதில் ஏற்றப்பட்டது",
    "AGENT_ENTERED": "ஏஜெண்ட் உள்ளிடப்பட்டது",
    "EXPECTED_FORMAT": "எதிர்பார்க்கப்பட்ட வடிவம்",
    "INPUT_VALUES": "உள்ளீடு மதிப்புகள்",
    "RESTART": "மீண்டும் தொடங்கு",
    "START_OVER": "மீண்டும் தொடங்கு",
    "RESTART_CAPTURE": "பிடித்த உள்ளீட்டுடன் மீண்டும் தொடங்கு",
    "CANCEL": "ரத்து செய்",
    "INTERRUPT_DIALOG": "தடுப்பதற்கான உரையாடல் பணி",
    "RUN": "இயங்கு",
    "RUN_AGENT": "ஏஜெண்ட் உள்ளீடுடன் இயங்கு",
    "STEP": "படி",
    "DIALOG_TASK": "உரையாட பணி",
    "FAQ": "செயல்பாடுகள்",
    "SNIPPET": "பதில்கள்",
    "ARTICLE": "இணைய பக்கங்கள்",
    "FILE": "கோப்புகள்",
    "SUGGESTED": "பரிந்துரைக்கப்பட்டது",
    "ALL_DIALOG": "எல்லா உரையாட பணிகளும்",
    "DIALOG_TEXT": "உரையாடல்",
    "INTENT_IDENTIFIED": "வாடிக்கையாளர் பேச்சு",
    "NOT_WHAT_LOOKING": "தவறான பரிந்துரை?",
    "BOT": "கருவி",
    "CUSTOMER": "வாடிக்கையாளர்",
    "YOU": "நீங்கள்",
    "TERMINATE_CONV": "உரையாட பணி முடக்கு",
    "TERMINATE_CONV_DESC": "நீங்கள் உரையாட பணியை முடக்க வேண்டும் என்று உறுதியாக உள்ளீடு செய்கிறீர்களா? ஏஜெண்ட் ஏஐ இன்னும் பரிந்துரைகளை அளிக்க முடியாது.",
    "YES_TERMINATE": "ஆம், முடக்கு",
    "NO_CANCEL": "இல்லை, ரத்து செய்",
    "OVERRIDE_CONTINUE": "மீறும் முறையொன்றில் தொடருங்கள்",
    "SUMMARY_TEXT": "சுருக்கம்",
    "SUBMIT": "சமர்ப்பிக்க",
    "INTERRUPT_OCCURED": "உறுதிப்படுத்தல் நடந்தது",
    "IDENTIFIED_INTENT": "முன்னோட்டம் அறியப்பட்டது",
    "INTERRUPT_DESC": "இதை இயங்கும்போது உங்கள் உரையாட பணி முடக்கப்படும்.",
    "ACCEPT_RUN": "ஏற்கவும் மற்றும் இயங்கு",
    "RUN_LATER": "பின்னிலையில் இயங்கு",
    "KNOW_MORE": "மேலும் அறிய",
    "MORE_TEXT": "மேலும்",
    "LESS_TEXT": "குறைவு",
    "VIEW_MORE": "மேலும் காட்டு",
    "VIEW_LESS": "குறைவாக காட்டு",
    "SHOW_MORE_FAQ": "மேலும் சமூகம் காட்டு",
    "SHOW_LESS_FAQ": "குறைவாக சமூகம் காட்டு",
    "SHOW_MORE_ARTICLE": "மேலும் இணைய பக்கங்கள் காட்டு",
    "SHOW_LESS_ARTICLE": "குறைவாக இணைய பக்கங்கள் காட்டு",
    "SHOW_MORE_SNIPPET": "மேலும் பதில்களை காட்டு",
    "SHOW_LESS_SNIPPET": "குறைவாக பதில்களை காட்டு",
    "SHOW_MORE_FILES": "மேலும் கோப்புகளை காட்டு",
    "SHOW_LESS_FILES": "குறைவாக கோப்புகளை காட்டு",
    "VIEW_ALL_DIALOG": "அனைத்து உரையாடல்களையும் காட்டு",
    "VIEW_FEW_DIALOG": "சில உரையாடல்களையும் காட்டு",
    "HELP_FULL": "உதவுமா?",
    "THANKYOU": "நன்றி!",
    "EXPAND_MORE": "பரப்பு / மேலும்",
    "CLOSE_TEXT": "மூடு",
    "STARTED": "தொடங்கப்பட்டது",
    "ENDED": "முடிவு செய்யப்பட்டது",
    "VIEW_FULL_ARTICLE": "இணைய பக்கத்தைக் காட்டு",
    "VIEW_FULL_FILE": "கோப்பைக் காட்டு",
    "COPIED": "நகல் எடுக்கப்பட்டது",
    "SENTI_ANALY": "உணர்வு பகுப்பாய்வு",
    "WRONG_SUGGESTION": "தவறான பரிந்துரைகள்",
    "INCORRECT_INTENT": "தவறான நோக்கம்",
    "ACCIDENTAL_CLICK": "ஏற்கனவே கிளிக் செய்யப்பட்டது",
    "TIME_TAKING": "நேரம் எடுத்து கொள்",
    "OTHER": "பிற",
    "PLAYBOOK_EMPTY_MSG": "பிளேபுக்கைத் தேர்வு செய்",
    "PLAYBOOK_EMPTY_DESC": "அஜெண்ட் ஏஐ எல்லா கிடைக்கும் பிளேபுக்களுக்கும் நான்காம் இலக்குகளான அனைத்து பிளேபுக்களையும் ஏஜெண்ட் ஏஐ ஏடத்துக்காகத் தேர்வு செய்ய முடியாது. 'பிளேபுக்கைத் தேர்வு செய்ய' என்பதை அணுக கிளிக் செய்க.",
    "STAGE": "படி",
    "PROCEED_TO_CLOSE": "மூடுவதற்கு முன்னால் முன்னேறு",
    "RECOMENDED_PLAYBOOK": "பரிந்துரைக்கப்பட்ட பிளேபுக்கை",
    "PRIMARY_SCRIPTS": "முதன்மை கட்டளைகள்",
    "DYNAMIC_SCRIPTS": "நாடகக் கட்டளைகள்",
    "RESUME": "தொடருங்கள்",
    "ENABLE_CLOSE": "மூடுவதற்கு முன்னால் முட்டனை கிளிக் செய்க",
    "LIST_VIEW": "பட்டியல் பார்க்க",
    "TERMINATE": "முடக்கு",
    "MINIMIZE": "குறைக்க",
    "MAXIMIZE": "அதிகபட்சமாக்கு",
    "NO_SEARCH_RESULT": "தேடல் முடிவு கிடைக்கவில்லை",
    "SENTIMENT_AWAITING": "உணர்வுக்காக காத்திருக்கிறேன்",
    "POSITIVE": "நேர்ம்",
    "NEGATIVE": "எதிர்மறை",
    "ASSOCIATED_WORK_NOTES": "கடைசி தீர்ப்பு குறிப்புகள்",
    "AGENT_JOINED_CONV": "ஏஜெண்ட் உரையாடலில் சேர்ந்தார்",
    "AUTOSCROLL_ASSIST": "தானாக நகர்த்த உதவும் தாபம் உள்ளடக்கம்",
    "FILE_SIZE_MSG": "கோப்பு அளவு 25MB க்குள் இருக்க வேண்டும். மீண்டும் முயற்சி செய்க.",
    "OVERRIDE_BTN": "மீறல்",
    "CHOOSE_FILE": "கோப்பைத் தேர்வு செய்",
    "SUMMARY_ERROR_TEXT": "மன்னிக்கவும், ஆனால் இந்த உரையாடலுக்கான சுருக்கம் உருவாக்குவதில் சிக்கல் ஏற்பட்டுள்ளது. உங்கள் சுருக்கத்தை உருவாக்குக.",
    "ASK_A_QUESTION": "ஒரு கேள்வி கேட்க",
    "COPY" : "நகல்",
    "TELL_US_MORE": "மேலும் கூறுங்கள்",
    "PLAYBOOK": "பிளேபுக்",
    "THANKS_FEEDBACK": "உங்கள் கருத்துக்கான நன்றி",
    "SOMETHING_WRONG": "செய்யும் போது சில பிரச்சினைகள் ஏற்பட்டன",
    "CLICK_ERROR_DETAILS": "தவறான விவரங்களை காண கிளிக் செய்யவும்",
    "NO_ACTIVE_PLAYBOOK": "செயலில் உள்ள விளையாட்டு புத்தகம் இல்லை",
    "REPHRASE_QUESTION": "உங்கள் கேள்வியை மீண்டும் சொல்வதற்கான முயற்சியா அல்லது வேறு எதையாவது கேட்க முடியுமா?",
    "VIEW_FULL_ARTICLE_2": "முழு கட்டுரையை காண்க",
    "VIEW_FULL_FILE_2": "முழு கோப்பை காண்க",
    "INTERNAL_INFO": "உள்ளக தகவல்",
    "SOURCES": "மூலங்கள்",
    "CONVERSATION_SUMMARY": "உரைச்சுவையின் சுருக்கம்",
    "WAITING": "காத்திருக்கிறேன்",
    "WIDGET_DISABLED": "விஜெட்டை நிறுத்தப்பட்டுள்ளது",
    "AI_SETTINGS_DISABLED": "AI அமைப்புகள் நிறுத்தப்பட்டுள்ளன! AI நிர்வாகியுடன் தொடர்பு கொள்ளவும்",
    "SERVER_CONNECTION_ERROR": "சேவையகத்துடன் இணைக்கும்போது தவறு",
    "VIEW": "காண்க",
    "ATTACHMENT_INPUT": "கட்டணம் உள்ளீடு",
    "TYPE_SUMMARY": "சுருக்கத்தை அடிக்கடி செய்யவும்",
    "BY":"வழி",
    GENERATE_SUMMARY: "சுருக்கத்தை உருவாக்கு",
    PREV_SUMMARIES: "முந்தைய உருவாக்கப்பட்ட சுருக்கங்கள்",
    DIALOG_WORKFLOWS: "உரையாடல் பணிப்பாய்வுகள்",
    SHOW_ALL_DIALOG: "அனைத்து உரையாடல் பணிகளையும் காட்டு",
    SHOW_ALL_DIALOGS: "அனைத்து உரையாடல்களையும் காட்டு",
    CUSTOM_TAB: "தனிப்பயன் தாவல்",
    AGENT_INPUT: "ஏஜெண்ட் உள்ளீடு",
    CUSTOM_EMPTY_MSG: "செயலில் உள்ள விளையாட்டு புத்தகம் இல்லை",
    CUSTOM_TAB_DESC: "ஒரு விளையாட்டு புத்தகத்தை தொடங்க, திரையின் கீழே உள்ள பட்டியலிலிருந்து ஒன்றை இயக்கவும்.",
    SUBMIT_OVERALL_FEEDBACK: "மொத்த பதில்களை சமர்ப்பிக்கவும்",
    FEEDBACK_POPUP_SUBTITLE: "விஜெட்டு மற்றும் அதன் செயல்பாடுகளைப் பற்றிய உங்கள் அனுபவம்",
    FEEDBACK_SATISFIED: "நன்றி",
    FEEDBACK_UNSATISFIED: "நன்றி இல்லை",
    FEEDBACK_PROVIDE_REASONS: "மேலும் தகவல்கள் கொடுக்கவும்",
    FEEDBACK_TITLE: "பதில்கள்",
    "AGENTIC_THINKING" : "சிந்திக்கிறது",
    "AGENTIC_AGENT_TITLE" : "முகவர்",
    "AGENTIC_COPILOT_MODE_TITLE" : "ஏஜென்டிக் கோபிலாட் மோட்",
    "AGENTIC_SENDING_MESSAGE" : "அனுப்புகிறது...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot உங்கள் உரையாடலைச் செயலில் கேட்டுக்கொண்டிருக்கிறது மற்றும் தானாக உதவ தயாராக உள்ளது",
    "AGENTIC_SEARCH_RESULTS" : "ஏஜென்ட் முடிவுகள்"
}